export default "__VITE_ASSET__c3b3d896__"